import API from "core/api/axios/base";
import DependenteErrorHandler from "core/api/handler/DependenteErrorHandler";
export function SendInvite(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token,
    },
    withCredentials: true
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.put(
    `${process.env.REACT_APP_DEPENDENTE_NUMBER_LIST}/invite`,
    data,
    config
  )
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = DependenteErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
export function ResendInvite(data, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token,
    },
    withCredentials: true,
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.post(
    `${process.env.REACT_APP_DEPENDENTE_NUMBER_LIST}/invite`,
    data,
    config
  )
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = DependenteErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
export function DeleteInvite(params, token) {
  let config = {
    headers: {
      "content-type": "application/json",
      "x-client-key": process.env.REACT_APP_CLIENT_KEY,
      Authorization: "Bearer " + token,
      "x-accesstoken": token,
    },
    withCredentials: true,
    data: params,
  };
  config.headers['x-credentials-key'] = process.env.REACT_APP_X_CREDENTIALS_KEY;

  return API.delete(
    `${process.env.REACT_APP_DEPENDENTE_NUMBER_LIST}/invite`,
    config
  )
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const errorHandler = DependenteErrorHandler(error);
      const responseError = {
        ...errorHandler,
      };
      return responseError;
    });
}
